import { render, staticRenderFns } from "./ViewBusinessAccount.vue?vue&type=template&id=e6b502f6&scoped=true"
import script from "./ViewBusinessAccount.vue?vue&type=script&lang=js"
export * from "./ViewBusinessAccount.vue?vue&type=script&lang=js"
import style0 from "./ViewBusinessAccount.vue?vue&type=style&index=0&id=e6b502f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b502f6",
  null
  
)

export default component.exports